module.exports = __webpack_public_path__ + "img/code.9be6204b.jpg";